export default {
  deviceSettings: {
    branchId: 'ID de sede',
    companyKey: 'Clave de la empresa',
    deviceId: 'ID de dispositivo',
    headingRegister: 'Registrar dispositivo',
    headingUpdate: 'Cambiar el código de acceso de la configuración',
    invalidDeviceReference: 'Su dispositivo puede haber sido desactivado por vuestro administrador.',
    passcode: 'Código de acceso',
    pleaseWaitRegister: 'Por favor, espere mientras registramos vuestro  dispositivo',
    pleaseWaitUpdate: 'Por favor, espere mientras actualizamos vuestro dispositivo',
    registrationFailed: 'Fallo en el registro del dispositivo',
    settingsPasscode: 'Código de acceso de la configuración',
    newSettingsPasscode: 'Not Implemented.',
    // TODO: Translate (PWA)
    settingsPasscodeConfirm: 'Confirmar el código de acceso de la configuración',
    successRegister: 'Se ha registrado con éxito. ¡Su dispositivo ha sido registrado!',
    successUpdate: 'Se ha registrado con éxito. ¡Su dispositivo ha sido actualizado!',
    updateFailed: 'Fallo en la actualización del dispositivo'
  }
};